/* Shopify related products replace the published-product fallback when present. */
(() => {
  if (customElements.get('catalog-recommendations')) return;
  customElements.define('catalog-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.loaded || this.request) return;
      this.syncVisibility();
      this.request = new AbortController();
      const url = new URL(this.dataset.url, location.origin);
      url.searchParams.set('sections', this.dataset.sectionId);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      fetch(url, { signal: this.request.signal, headers: { Accept: 'application/json' } })
        .then((response) => { if (!response.ok) throw new Error('Recommendations unavailable'); return response.json(); })
        .then((payload) => {
          const html = payload?.[this.dataset.sectionId];
          if (!html) return;
          const content = new DOMParser().parseFromString(html, 'text/html').querySelector('catalog-recommendations');
          const nextGrid = content?.querySelector('[data-rail-grid]');
          if (!nextGrid?.querySelector('.mto-card') || !this.isConnected) return;
          this.innerHTML = content.innerHTML;
          this.loaded = true;
          this.syncVisibility();
        }).catch(() => {}).finally(() => { this.request = null; this.syncVisibility(); });
    }
    syncVisibility() {
      this.hidden = !this.querySelector('.mto-card');
    }
    disconnectedCallback() { this.request?.abort(); }
  });
})();
